import {NumberOnly} from './input-directives';

export default {
    install (Vue) {
        Vue.directive('numberOnly', NumberOnly);
    }
}



// WEBPACK FOOTER //
// ./src/directives/index.js